import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import LabCarousel from "../components/LabCarousel"
import rightArrow from "../assets/img/right-arrow.png"
import checkModal from "../assets/img/check-modal.png"
import onelab from "../assets/img/one-image-lab.webp"
import pazarlama from "../assets/img/wp-pazarlama.webp"
import qrcode from "../assets/img/qrcode.webp"

class FlatartLab extends Component {
  constructor(props) {
    super(props)
    this.state = {
      display: false,
      value: "",
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    e.preventDefault()
    this.setState({ value: e.target.value })
  }

  showModal() {
    this.setState({ display: !this.state.display })
    document.querySelector(".check-modal").classList.add("active-modal")
  }

  closeModal() {
    this.setState({ display: !this.state.display })
    document.querySelector(".check-modal").classList.remove("active-modal")
  }

  handleSubmit(e) {
    e.preventDefault()
    const title = document.title.split("|", 1).toString()
    const response = fetch("https://forms.flatart.com.tr/index.php?r=app%2Ff&id=7", {
      method: "POST",
      body: JSON.stringify({
        text_327649: title,
        text_204202: document.querySelector("#site").value,
        text_775908: document.querySelector("#name").value,
        text_532192: document.querySelector("#email").value,
      }),
      headers: { "Content-type": "application/json; charset=UTF-8" },
    })
    response.then(res => {
      if (res.status === 200) {
        document.querySelector(".status").innerHTML = "Your message has been sent successfully."
      } else {
        document.querySelector(".status").innerHTML = "An error occurred."
      }
    })
  }

  render() {
    return (
      <Layout>
        <SEO
          title="Flatart Lab | AI-Powered Product Ecosystem"
          description="Flatart Lab brings together Popupsmart, LiveChatAI, WhatsApp Marketing Tool, and QR Code Dynamic — technology products that strengthen your digital marketing."
        />

        <div className="seo-service gads container">
          <div className="baslik-ai">
            <h1 className="h1-ai-h1">What is Flatart Lab?</h1>
          </div>

          <div className="row labst">
            <LabCarousel />
          </div>

          <div className="row labh2">
            <div className="ai-ort uptade">
              <h2 className="h2-ai-h2">Strengthen Your Marketing with Technology, Discover Flatart Lab Products!</h2>
              <p className="flatlab-p now">
                Meet Flatart Lab — our platform developed to make digital marketing processes smarter and more effective with AI! With our <strong>Popupsmart</strong>, <strong>LiveChatAI</strong>, <strong>WhatsApp App</strong>, and <strong>QR Code Dynamic</strong> products, we aim to strengthen brands' strategies day by day. Providing AI-powered chatbots, automated sales support systems, and dynamic message flows, we continue to serve tens of thousands of users and thousands of active customers in more than 50 countries through our US-based subsidiary.
              </p>
            </div>
          </div>

          <div className="row" id="popupsmart-section">
            <div className="col-md-6 d-flex align-items-center">
              <div className="lab-flex">
                <h2 className="lab-h2">Popupsmart</h2>
                <p className="lab-p">
                  Started development in 2018 based on Flatart customers' needs and spun off as a company in 2019, Popupsmart is an innovative startup that enables quick and easy creation of conversion campaigns and pop-ups for websites.
                </p>
                <p className="lab-p">
                  Today it continues to grow with more than 10,000 users and 1,000+ active monthly paying customers. Popupsmart generates revenue through a monthly subscription model.
                </p>
                <p className="ps-link">
                  <span className="emoji-lab">👉</span>
                  <span className="ps-text">
                    To discover more, visit <a className="lab-popup" href="https://popupsmart.com" target="_blank" rel="noopener noreferrer">Popupsmart's website</a>
                  </span>
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <div className="image-container">
                <img className="lab-one-lab" alt="Popupsmart" src={onelab} loading="lazy" />
              </div>
            </div>
          </div>

          <div className="row two reverse-mobile lab" id="livechatai-section">
            <div className="col-md-6 d-flex align-items-center">
              <div className="image-video">
                <video
                  src="https://cdn.prod.website-files.com/645a5c180d74260fa26eedc9%2F684ac5a3868221d3058cc76d_Original%20File-transcode.webm"
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-auto"
                />
              </div>
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <div className="lab-flex">
                <h2 className="lab-h2">LiveChatAI</h2>
                <p className="lab-p">
                  LiveChatAI serves as our AI-based intelligent chatbot application. It was developed to meet the needs of agency clients as LLM models became widespread in our lives. The first version of LiveChatAI, released in 2023, provides AI-powered live support solutions for companies using ChatGPT and all other advanced models.
                </p>
                <p className="lab-p">
                  LiveChatAI, which eliminates coding processes, helps you manage customer relationships more efficiently and in an organized manner. With its first version released in just 8 months using React on Vercel, our product has reached over 1,000 active users and 150 monthly paying customers.
                </p>
                <p className="ps-link">
                  <span className="emoji-lab">👉</span>
                  <span className="ps-text">
                    To discover more, visit <a className="lab-popup" href="https://livechatai.com/" target="_blank" rel="noopener noreferrer">LiveChatAI's website</a>
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="row padding50" id="whatsapp-section">
            <div className="col-md-6 d-flex align-items-center">
              <div className="lab-flex">
                <h2 className="lab-h2">WhatsApp Marketing Tool</h2>
                <p className="lab-p">
                  Flatart's WhatsApp Marketing product was launched in 2025 as an innovative marketing solution developed by Flatart's expert software team. The process started by analyzing different industries' needs at the idea stage, and we combined the power of WhatsApp Business API with customized scenarios. Thus, we developed a product that provides end-to-end conversion support for brands — not just bulk messaging, but also personalized communication, automation, CRM integration, and detailed reporting.
                </p>
                <p className="ps-link">
                  <span className="emoji-lab">👉</span>
                  <span className="ps-text">
                    To discover more, visit <a className="lab-popup" href="/whatsapp-marketing/" target="_blank" rel="noopener noreferrer">WhatsApp Marketing page</a>
                  </span>
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <div className="image-container">
                <img className="lab-one-lab" alt="WhatsApp Marketing" src={pazarlama} loading="lazy" />
              </div>
            </div>
          </div>

          <div className="row two reverse-mobile lab" id="qrcode-section">
            <div className="col-md-6 d-flex align-items-center">
              <div className="image-container">
                <img className="lab-one-lab" alt="QR Code Dynamics" src={qrcode} loading="lazy" />
              </div>
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <div className="lab-flex">
                <h2 className="lab-h2">QR Code Dynamics</h2>
                <p className="lab-p">
                  Our product offering flexibility and scalability for businesses with dynamic QR code solutions launched in 2023 and quickly reached a wide user base.
                </p>
                <p className="lab-p">
                  QR Code Dynamics, with over 500 active paying customers today, periodically serves over 20,000 users. The product providing trackable, updatable, and reliable QR code infrastructure for businesses enables brands to easily adapt their marketing and customer interaction processes to the digital world.
                </p>
                <p className="ps-link">
                  <span className="emoji-lab">👉</span>
                  <span className="ps-text">
                    To discover more, visit <a className="lab-popup" href="https://qrcodedynamic.com/" target="_blank" rel="noopener noreferrer">Qr Code Dynamic's website</a>
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div>
            <div className="h3-labs">Results that make a difference.</div>
            <p className="fark-labp">
              We open the doors to a new world with our technology and product development capabilities. We make your brand stand out with the capabilities of the digital world.
            </p>
            <div className="client-lab-btn">
              <a className="red-button black" href="/contact/">Let's Meet</a>
              <button className="red-button" onClick={() => this.showModal()}>
                Get your special offer <img className="lab-right" src={rightArrow} alt="" />
              </button>
            </div>

            <div className="check-modal">
              <span onClick={() => this.closeModal()}>X</span>
              <h2 className="form-head">Fill the form.</h2>
              <p className="form-desc">Enter your information in the fields to get information, and we will get back to you as soon as possible.</p>
              <div className="check-modal_container">
                <form onSubmit={e => this.handleSubmit(e)}>
                  <input type="text" name="text_204202" id="site" required placeholder="Enter your website." />
                  <input type="text" id="name" required name="text_775908" placeholder="Enter your name." />
                  <input type="email" id="email" required name="text_532192" value={this.state.value} onChange={this.handleChange} autoFocus={true} placeholder="Enter your email address." />
                  <button>SEND</button>
                  <div className="status"></div>
                </form>
                <img alt="" src={checkModal} />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default FlatartLab
